import { render } from "./Contact.vue?vue&type=template&id=02de2322&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=02de2322&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02de2322"]])

export default __exports__